module.exports = __webpack_public_path__ + "static/img/3.06aa002.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zz/3.png
// module id = XLi7
// module chunks = 1